<template>
  <yd-dialog title="营销短信导入" :visible.sync="showUpload" width="450px" append-to-body>
    <el-form ref="uploadForm" :rules="rules" :model="form" size="mini" label-width="120px">
      <el-form-item label="供应商" prop="merchantId">
        <yd-merchant-selector v-model="form.merchantId" :styles="{ width: '100%' }" />
      </el-form-item>
      <el-form-item label="生效时间" prop="localDate">
        <el-date-picker
          v-model="form.localDate"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item label="短信内容" prop="msg">
        <el-input
          type="textarea"
          rows="3"
          maxlength="300"
          show-word-limit
          v-model.trim="form.msg"
          clearable
          placeholder="请输入"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item label="发送号码数" prop="num">
        <el-input-number
          v-model="form.num"
          :min="1"
          :controls="false"
          :precision="0"
          style="width: 230px; margin-right: 5px"
        />
        <span>个号码</span>
      </el-form-item>
    </el-form>
    <el-row>
      <el-col align="center">
        <el-button type="primary" :loading="loading" @click="handleSubmit" size="mini">
          导 入
        </el-button>
        <el-button @click="closeUploadDialog" size="mini">取 消</el-button>
      </el-col>
    </el-row>
  </yd-dialog>
</template>

<script >
import { ref, reactive, inject, watch, nextTick } from '@vue/composition-api';
import { Message } from 'element-ui';
import dayjs from 'dayjs';
import { batchImportSms } from '@/api/source/index.js';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const showUpload = inject('showUpload');
  const closeUploadDialog = inject('closeUploadDialog');
  const reset = inject('reset');
  const form = ref({
    merchantId: '',
    localDate: dayjs().format('YYYY-MM-DD'),
    msg: '',
    num: 1
  });
  const uploadForm = ref(null);
  watch(showUpload, v => {
    if (v) {
      form.value = {
        merchantId: '',
        localDate: dayjs().format('YYYY-MM-DD'),
        msg: '',
        num: 1
      };
      nextTick(() => {
        uploadForm.value.clearValidate && uploadForm.value.clearValidate();
      });
    }
  }, {
    immediate: true
  });
  const rules = reactive({
    merchantId: [{
      required: true,
      message: '请选择供应商',
      trigger: 'change'
    }],
    localDate: [{
      required: true,
      message: '请选择生效时间',
      trigger: 'change'
    }],
    msg: [{
      required: true,
      message: '请填写短信内容',
      trigger: 'blur'
    }],
    num: [{
      required: true,
      message: '请填写发送号码数',
      trigger: 'blur'
    }]
  });
  const loading = ref(false);
  const handleSubmit = () => {
    uploadForm.value.validate(async valid => {
      if (!valid) {
        Message.info('请完善内容后再导入');
        return;
      }
      loading.value = true;
      const res = await batchImportSms(form.value);
      loading.value = false;
      const {
        code
      } = res || {};
      if (code !== 0) {
        return;
      }
      Message.success('数据导入成功');
      closeUploadDialog();
      reset();
    });
  };
  return {
    showUpload,
    closeUploadDialog,
    form,
    uploadForm,
    rules,
    loading,
    handleSubmit
  };
};
export default __sfc_main;
</script>

<style lang="scss" scoped></style>
